import React from 'react';
import { Wrench } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] py-10 border-t border-[#262626]" data-id="element-87">
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-88">
        <div className="flex items-center gap-2 text-white" data-id="element-89">
          <Wrench className="w-5 h-5 text-[#F59E0B]" data-id="element-90" />
          <span className="font-heading text-xl tracking-wide font-bold" data-id="element-91">
            MECÁNICA BÁSICA
          </span>
        </div>

        <div className="text-[#9CA3AF] text-sm" data-id="element-92">
          © 2026 MegaPack Mecánica Básica. Todos los derechos reservados.
        </div>

        <div className="flex items-center gap-6 text-sm text-[#9CA3AF]" data-id="element-93">
          <a href="#" className="hover:text-[#F59E0B] transition-colors" data-id="element-94">
            Términos
          </a>
          <a href="#" className="hover:text-[#F59E0B] transition-colors" data-id="element-95">
            Privacidad
          </a>
          <a href="#" className="hover:text-[#F59E0B] transition-colors" data-id="element-96">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}